import { render } from "./send-notification.vue?vue&type=template&id=6fb57340&scoped=true"
import script from "./send-notification.vue?vue&type=script&lang=js"
export * from "./send-notification.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./send-notification.vue?vue&type=style&index=1&id=6fb57340&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroAdmin\\marriage_beauro_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb57340"]])

export default __exports__